<template>
  <b-row class="px-lg-2 px-4">
    <b-col cols="12" class="mb-4">
      <b-modal
        v-model="open"
        title="Detalhes do Serviço"
        size="lg"
        header-bg-variant="orange"
        header-text-variant="light"
        centered
        hide-footer
        no-close-on-backdrop
      >
      <b-card class="mt-2">
        <b-row>
          <b-col cols="12">
              <div class="bg-warning py-1">
                <h5 class="text-center text-light">Serviço</h5>
              </div>
          </b-col>
          <b-col cols="12" md="12" class="mt-3">
            <strong class="fs-20">Nome</strong>
            <div>
              <span class="fs-20 ml-1">{{ service.service_name }}</span>
            </div>
          </b-col>
          <b-col cols="12" md="3" class="mt-2">
            <strong class="fs-20">Preço: </strong>
            <div>
              <span class="fs-20">{{ service.service_price }}</span>
            </div>
          </b-col>
          <b-col cols="12" md="3" class="mt-2">
            <strong class="fs-20">Garantia: </strong>
            <div class="fs-20">
              <span class="mr-1" >{{ service.service_guarantee }}</span>
              <span v-if="service.guarantee >1"> meses</span>
              <span v-else>mês</span>
            </div>
          </b-col>
          <b-col cols="12" md="3" class="mt-2">
            <strong class="fs-20">Prazo de instalação: </strong>
            <div class="fs-20">
              <span class="mr-1">{{ service.deadline }}</span>
              <span v-if="service.deadline >1"> horas</span>
              <span v-else>hora</span>
            </div>
          </b-col>
          <b-col cols="12" md="3" class="mt-2">
            <strong class="fs-20">Tipo de Serviço: </strong>
            <div>
              <span class="fs-20">{{ service.service_type == 1 ? "Serviço de Instalação" : "" }}</span>
            </div>
          </b-col>
          <b-col cols="12" class="mt-2">
            <strong class="fs-20">Serviços Inclusos: </strong>
            <div>
              <span class="fs-20">{{ service.services_included }}</span>
            </div>
          </b-col>
          <b-col cols="12" class="mt-2">
            <strong class="fs-20">Serviços não Inclusos: </strong>
            <div>
              <span class="fs-20">{{ service.services_not_included }}</span>
            </div>
          </b-col>
          <b-col cols="12" class="mt-2">
            <strong class="fs-20">Preparação para Instalação: </strong>
            <div>
              <span class="fs-20">{{ service.prepare_installation }}</span>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-row>
        <b-col cols="12" md="6" class="mt-4">
          <b-button
            variant="danger"
            block
            @click="open=false"
          >
          Fechar
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    </b-col>
  </b-row>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      open: false,
      service: [],
    }
  },

  methods: {
    toggleOpen(data = []) {
      this.open = !this.open;
      this.service = data.item;
    },
    linkFotos(origem) {
      if(origem == 'Belenus' || origem == 'fixadores') {
        return 'https://storage.googleapis.com/fotos-prd/';
      } else {
        return process.env.VUE_APP_FOTOS_URL;
      }
    },
  }
}
</script>
